import {
  Component,
  computed,
  EventEmitter,
  Inject,
  inject,
  Output,
  Signal,
} from '@angular/core';
import { InputTextModule } from 'primeng/inputtext';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { AsyncPipe, JsonPipe } from '@angular/common';
import { MatError } from '@angular/material/form-field';
import { SharedModule } from '../../../../../../../../shared/shared.module';
import { MatOption } from '@angular/material/autocomplete';
import { DataCatalogueService } from '../../../../../data-access/services/data-catalogue.service';
import { WFSCapability } from '../../../../../data-access/models/getcapabilities.model';
import { FormControl } from '@angular/forms';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { CreateEvent } from '../../../../../../../../@core/events/createEvent';

@Component({
  selector: 'app-list-wfs-get-capabilities-layers',
  standalone: true,
  imports: [
    AsyncPipe,
    MatError,
    MatRadioButton,
    SharedModule,
    JsonPipe,
    MatOption,
    MatRadioGroup,
    InputTextModule,
  ],
  templateUrl: './list-wfs-get-capabilities-layers.component.html',
  styleUrl: './list-wfs-get-capabilities-layers.component.css',
})
export class ListWfsGetCapabilitiesLayersComponent {
  readonly catalogueService: DataCatalogueService =
    inject(DataCatalogueService);

  @Output() selectionEvent: EventEmitter<any> = new EventEmitter();
  capabilities: Signal<WFSCapability[]>;
  selectedLayer: WFSCapability;
  searchField: FormControl = new FormControl('');
  filteredCapabilities: Signal<WFSCapability[]>;

  constructor(public dialogRef: DialogRef<string>, @Inject(DIALOG_DATA) data) {
    this.capabilities = toSignal(
      this.catalogueService.WFSSGetCapabilities(data.url),
      { initialValue: null }
    );

    const searchFieldChanges = toSignal(
      this.searchField.valueChanges.pipe(map((value) => value.toLowerCase())),
      {
        initialValue: '',
      }
    );

    this.filteredCapabilities = computed(() =>
      this.capabilities().filter((cap) =>
        cap.title.toLowerCase().includes(searchFieldChanges())
      )
    );
  }

  cancel(): void {
    this.selectionEvent.emit(CreateEvent.cancel<any>());
    this.dialogRef.close();
  }

  setSelection(): void {
    this.selectionEvent.emit(
      CreateEvent.create<WFSCapability>(this.selectedLayer)
    );
    this.dialogRef.close();
  }

  get isDisabled(): boolean {
    return !this.selectedLayer;
  }
}
